import { Box, Card, Grid, IconButton, Stack, Typography, TextField, Tooltip } from "@mui/material";
import CommonLayout from "layouts/DashboardLayout";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import MDButton from "components/MDButton";
import { openCustomModalDialog, setModalLoader } from "../../../redux/slices/modalSlice";
import { uploadImage } from "../../../redux/slices/common";
import { useDispatch, useSelector } from "react-redux";
import AngleRightIcon from "common/customIcons/angle_right";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Link, useNavigate, useSearchParams, useParams } from "react-router-dom";
import EditIcon from "common/customIcons/edit";
import DeleteIcon from "common/customIcons/delete";
import { OpenInNewSharp } from "@mui/icons-material";
import colors from "assets/theme/base/colors";
import { openSnackbar } from "../../../redux/slices/common";
import {
  createHomepageHit,
  getHomePageById,
  getHomePageStateList,
  getLocationPageList,
} from "../../../redux/slices/homePage";
import { getAllCategory } from "../../../redux/slices/hyperwolf/products";
import MyAccountIcon from "common/customIcons/myAccount";
import ContactUsIcon from "common/customIcons/contactUs";
import BrandsIcon from "common/customIcons/brands";
import { getData } from "utilities/common";
import ActiveIcon from "common/customIcons/active";
import InActiveIcon from "common/customIcons/inactive";
import { homePageValidation } from "validations/homePage";
import { capitalizeText } from "utilities/common";
import MDBox from "components/MDBox";
import HeroSection from "./sections/hero-section";
import CategorySection from "./sections/category-section";
import CustomerReview from "./sections/customer-review";
import FavDeliverySection from "./sections/fav-delivery-section";
import ContentSection from "./sections/content-section";
import FAQSection from "./sections/faq-section";
import FooterSection from "./sections/footer-section";

export default function CreateHome({ isDefaultHomePage = false }) {
  const user = getData("login-user-info");
  const parseUser = JSON.parse(user);
  const [searchParams] = useSearchParams();
  const stateValue = searchParams.get("statename");
  const settingName = formatStateName(searchParams.get("statename"));
  const [stateName, setStateName] = useState(settingName);
  const [states, setStates] = useState([]);
  const [menuNameError, setMenuNameError] = useState("");
  const [activeItemIndex, setActiveItemIndex] = useState(null);
  const [draftItem, setDraftItem] = useState(null);
  const [overViewPageList, setOverViewPageList] = useState(false)
  const [siteMapPageList, setSiteMapPageList] = useState(false)
  const [traitsPageList, setTraitsPageList] = useState(false)
  const [quickLinksPageList, setQuickLinksPageList] = useState(false)
  const [careerPageList, setcareerPageList] = useState(false)


  const matchedState = states.find((item) => item.value === stateValue);
  const { id } = useParams();
  const {
    updateloading = false,
    // loading: getLoading = false,
    locationPageList,
  } = useSelector((state) => state.homePage);
  const [copyStatus, setCopyStatus] = useState("");
  const [gridMsg, setGridMsg] = useState("");
  const [cardErrors, setCardErrors] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [editingLocationId, setEditingLocationId] = useState(null);
  const [errors, setErrors] = useState({});
  const gridConfigs = [
    { key: "Two Column-Left", value: 3 },
    { key: "Two Column-Right", value: 3 },
    { key: "Full Width", value: 1 },
    { key: "Stacked Grid", value: 3 },
    { key: "Two Column", value: 2 },
    { key: "Equal", value: 2 },
    { key: "Triple Grid", value: 3 },
    { key: "Slider", value: 3 },
  ];
  const initialState = {
    isDefaultHomePage: false,
    title: "",
    status: "",
    stateName: "",
    stateCode: "",

    // ********************************** meta Section *************** ( type and value to be added )
    // metaProperties: {
    //   type:"meta_Section",
    //   value:"Meta Section",
    //   metaTitle: "",
    //   metaDescription: "",
    // },
    metaTitle: "",
    metaDescription: "",
    stateParagraph: "", //**** to add

    //********************************** hero Section ***************
    heroSection: {
      title: "",
      // type: "hero_Section",
      // value: "Hero Section",
      heroSectionPara: "", //**** to add
      banners: [],
    },
    // ********************************** category Section *************** ( type and value to be added )
    categorySection: [
      {
        categoryName: "",
        categoryHeading: "",
        bentoGridHeading: "",
        bentoGridHeading1: "",
        layoutType: "No Grid",
        defaultRedirectUrlEnable: false,
        defaultGridUrl: "",
        desktopBanner: {
          imageUrl: "",
          title: "",
          description: "",
          altText: "",
          redirectUrl: "",
        },
        mobileBanner: {
          imageUrl: "",
          title: "",
          description: "",
          altText: "",
          redirectUrl: "",
        },
        desktopGrid: [],
        mobileGrid: [],
        arrayIndex: 0,
      },
    ],

    // ********************************* customer Review to review ****************

    // customerSection: {
    //   customerReviews: "",
    //   type: "customer_Section",
    //   value: "Customer Section",
    // },
    customerReviews: "",
    //    ************** Favorite Delivery *********************

    deliverySection: {
      sectionTitle: "",
      sectionPara: "",
      // type: "delivery_Section",
      // value: "Delivery Section",
      subData: [
        {
          image: null,
          heading: "",
          subHeading: "",
          paragraph: "",
          deliveryId: crypto.randomUUID(),
        },
      ],
    },

    // *************************** faq section to review *************************
    faqSection: {
      // type: "faq_Section",
      // value: "FAQ Section",
      title: "",
      subData: [
        {
          question: "",
          answer: "",
          faqId: crypto.randomUUID(),
        },
      ],
    },
    // ************************** footer section to review *********************
    footerSection: {
      // type: "footer_Section",
      // value: "Footer Section",
      paragraph: `
    <p><strong style="color:#FF0000">WARNING:</strong> CANNABIS IS A SCHEDULE | CONTROLLED SUBSTANCE. KEEP OUT OF REACH OF CHILDREN AND ANIMALS. CANNABIS PRODUCTS MAY ONLY BE POSSESSED OR CONSUMED BY PERSONS 21 YEARS OF AGE OR OLDER UNLESS THE PERSON IS A QUALIFIED MEDICINAL PATIENT. THE INTOXICATING EFFECTS OF CANNABIS PRODUCTS MAY BE DELAYED UP TO TWO HOURS. CANNABIS USE WHILE PREGNANT OR BREASTFEEDING MAY BE HARMFUL. CONSUMPTION OF CANNABIS PRODUCTS IMPAIRS YOUR ABILITY TO DRIVE AND OPERATE MACHINERY. PLEASE USE EXTREME CAUTION.
    </p> <br>

    <p><strong style="color:#FF0000">C.A. PROP 65 WARNING:</strong> PRODUCTS SOLD HERE EXPOSE YOU TO CHEMICALS INCLUDING TETRAHYDROCANNBINOL (THC), WHICH ARE KNOWN TO THE STATE OF CALIFORNIA TO CAUSE BITH DEFECTS OR OTHER REPRODUCTIVE HARM. FOR MORE INFORMATION GOT TO WWW.P65WARNINGS.CA.GOV
    </p>

    <p style="text-align:center;">© HyperWolf 2025 <br> 2023.06.15(0.1.0)</p>
  `,
      locationList: [
        // {
        //   locationName: "",
        //   locationLink: "",
        //   location_id:"",
        // },
      ],
      overView: {
        name: "Overview",
        title: "Overview test",
        isActive: true,
        cta: [
          {
            label: "",
            url: "",
            openNewTab: false,
          },
        ],
        description: "",
      },
      menusItems: {
        siteMap: {
          name: "Site Map",
          title: "Sitemap test",
          isActive: true,
          subData: [
            // { label: "Home", url: "/", icon: "",isActive=false, }
          ],
        },
        traits: {
          name: "Traits",
          title: "Traits test",
          isActive: true,
          subData: [
            // { label: "Home", url: "/", icon: "",isActive=false }
          ],
        },
        findYourCareer: {
          name: "Find Your Career",
          title: "Career test",
          isActive: true,
          subData: [
            // { label: "Home", url: "/", icon: "",isActive=false }
          ],
        },
        quickLinks: {
          name: "Quick Links",
          title: "quickLinks test",
          isActive: true,
          subData: [
            // { label: "Home", url: "/", icon: "",isActive=false }
          ],
        },
      },
    },
    createdBy: "",
  };
  const cleanQuillValue = (val = "") => {
    if (!val) return "";

    const trimmed = val.trim();

    if (
      trimmed === "<p><br></p>" ||
      trimmed === "<br>" ||
      trimmed === "<br/>" ||
      trimmed === "<p></p>"
    ) {
      return "";
    }

    return val;
  };

  const handleCopyLink = (Link) => {
    navigator.clipboard
      .writeText(Link)
      .then(() => {
        setCopyStatus("Copied!");
        setTimeout(() => setCopyStatus(""), 1000); // Clear message after 2 seconds
      })
      .catch(() => {
        setCopyStatus("Failed to copy");
        setTimeout(() => setCopyStatus(""), 1000); // Clear message after 2 seconds
      });
  };

  const [formData, setFormData] = useState({
    ...initialState,
    createdBy: parseUser?.name,
    stateName: isDefaultHomePage ? "HomePage " : stateName,
    stateCode: isDefaultHomePage ? "HP" : matchedState?.stateCode || "",
    title: isDefaultHomePage ? "Home" : `${stateName} Home Page`,
  });

  // const [formData, setFormData] = useState(obj);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mainGridApiRef = useRef("");
  const { banners = {}, isLoading: loading = false } = useSelector((state) => state.common);
  const { categories: allCategoryData = {} } = useSelector((state) => state.hyperwolfProducts);
  const [value, setValue] = React.useState("1");
  const bannerCallbackRef = useRef(null);
  const [newLocationName, setNewLocationName] = useState("");
  const [newLocationLink, setNewLocationLink] = useState("");
  const [newLocationId, setNewLocationId] = useState("");
  const [pageList, setPageList] = useState({})
  const [categoryCards, setCategoryCards] = React.useState([
    { id: Date.now(), tabValue: "1", selectedCategoryId: "" },
  ]);
  const [] = useState({
    meta: {},
    category: { categoryName: "", bentoHeading: "" },
  });
  const pageRef = useRef(0);
  const searchTermRef = useRef("");
  const gridRefApi = useRef(null);
  const { text } = colors;

  function getSortInfo(data) {
    if (!data || data.length === 0) {
      return null;
    }
    const sortModel = data[0];
    return {
      sortField: sortModel.colId,
      sortOrder: sortModel.sort,
    };
  }

  const getRows = async (params) => {
    gridRefApi.current = params;
    let sortInfo = null;
    if (params?.sortModel?.length) {
      sortInfo = getSortInfo(params.sortModel);
    }

    if (formData?.heroSection?.banners?.length > 0) {
      let rowData = formData.heroSection.banners.map((item) => ({
        ...item,
        desktop_image: item.desktop.imageFile || "",
        mobile_image: item.mobile.imageFile || "",
        url: item.destinationUrl || "",
        desktop_description: item.desktop.description || "",
        mobile_description: item.mobile.description || "",
        status: item.status === "active" ? "active" : "inactive",
        media_type: ["mp4", "webm"].includes(
          (item?.desktopImage?.split(".").pop() || "").toLowerCase()
        )
          ? "video"
          : "image",
        bannerId: item.bannerId,
      }));

      if (sortInfo) {
        rowData = sortLocalData(rowData, sortInfo);
      }

      return params.successCallback(rowData, rowData.length);
    }
  };

  const sortLocalData = (data, sortInfo) => {
    const { sortField, sortOrder } = sortInfo;

    return [...data].sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (sortOrder === "asc") {
        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
      } else {
        if (aValue > bValue) return -1;
        if (aValue < bValue) return 1;
        return 0;
      }
    });
  };
  // old code
  // const getRows = async (params) => {
  //   gridRefApi.current = params;
  //   if (formData?.heroSection?.banners?.length > 0) {
  //     const rowData = formData.heroSection.banners.map((item) => ({
  //       ...item,
  //       desktop_image: item.desktop.imageFile || "",
  //       mobile_image: item.mobile.imageFile || "",
  //       url: item.destinationUrl || "",
  //       status: item.status === "active" ? "active" : "inactive",
  //       // status: (item.status = "published"),
  //       media_type: ["mp4", "webm"].includes(
  //         (item?.desktopImage?.split(".").pop() || "").toLowerCase()
  //       )
  //         ? "video"
  //         : "image",
  //       bannerId: item.bannerId, // ensure unique id for local items
  //     }));

  //     return params.successCallback(rowData, rowData.length);
  //   }
  // };
  const columnDefs = [
    {
      headerName: "Desktop Image/Video",
      field: "desktop_image",
      suppressMenu: false,
      flex: 1.25,
      sortable: false,
      minWidth: 160,
      cellRenderer: (props) => {
        const { data: item } = props;
        if (!item?.desktop_image) return null;
        return item?.mediaType === "video" ? (
          <video style={thumbnail} loop autoPlay playsInline muted>
            <source
              key={item.desktop_image}
              src={item.desktop_image}
              style={{ borderRadius: "10px" }}
              type="video/mp4"
            />
          </video>
        ) : (
          <img src={item.desktop_image} style={thumbnail} />
        );
      },
    },
    {
      headerName: "Mobile Image/Video",
      field: "mobile_image",
      suppressMenu: false,
      flex: 1.25,
      sortable: false,
      minWidth: 160,
      cellRenderer: (props) => {
        const { data: item } = props;
        if (!item?.mediaType) return null;
        return item?.mediaType === "video" ? (
          <video style={thumbnail} loop autoPlay playsInline muted>
            <source
              key={item.mobile_image}
              src={item.mobile_image}
              style={{ borderRadius: "10px" }}
              type="video/mp4"
            />
          </video>
        ) : (
          <img src={item.mobile_image} style={thumbnail} />
        );
      },
    },
    {
      headerName: "Destination URL",
      field: "url",
      flex: 1.75,
      sortable: false,
      minWidth: 220,
      suppressMenu: false,
      cellRenderer: (props) => {
        return props?.value ? (
          <Link target="_blank" style={linkStyle} to={props?.value}>
            {props?.value}
            <OpenInNewSharp />
          </Link>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Mobile Description",
      field: "mobile_description",
      flex: 2,
      sortable: false,
      suppressMenu: true,
      wrapText: true,
      minWidth: 280,
      cellRenderer: (props) => {
        return props?.value ? (
          <Tooltip title={capitalizeText(props?.value)} arrow placement="top">
            <MDBox textAlign="left">
              <Typography
                variant="p"
                // color="dark"
                lineHeight={1.25}
                // fontWeight="semibold"
                className="text-14 truncate line-1"
              >
                {capitalizeText(props?.value)}
              </Typography>
            </MDBox>
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Desktop Description",
      field: "desktop_description",
      flex: 2,
      sortable: false,
      suppressMenu: true,
      wrapText: true,
      minWidth: 280,
      cellRenderer: (props) => {
        return props?.value ? (
          <Tooltip title={capitalizeText(props?.value)} arrow placement="top">
            <MDBox textAlign="left">
              <Typography
                variant="p"
                color="dark"
                lineHeight={1.25}
                // fontWeight="semibold"
                className="text-14 truncate line-1"
              >
                {capitalizeText(props?.value)}
              </Typography>
            </MDBox>
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Media Type",
      field: "mediaType",
      flex: 1,
      minWidth: 120,
      suppressMenu: false,
      cellRenderer: (props) => {
        return props?.value ? props.value : "-";
      },
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      minWidth: 100,
      suppressMenu: false,
      cellRenderer: (props) => {
        const status = props.value?.toLowerCase();

        const isActive = status === "active";

        return (
          <Box
            display="flex"
            alignItems="center"
            className="status-col"
            color={isActive ? "#24CA49" : "#FF4D4D"} // red for inactive
          >
            {isActive ? (
              <ActiveIcon width="18px" height="18px" flex="none" />
            ) : (
              <InActiveIcon width="18px" height="18px" flex="none" />
            )}

            <Typography variant="caption" fontWeight="regular" ml={0.5} textTransform="capitalize">
              {props.value}
            </Typography>
          </Box>
        );
      },
    },

    {
      headerName: "Actions",
      sortable: false,
      cellRenderer: (props) => {
        return (
          <Box display="inline-flex" alignItems="center">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onEditClicked(props.data); // send current row data
              }}
              color="primary"
              size="small"
              variant="primary"
            >
              <EditIcon width="16px" height="16px" />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                deleteHandler(props.data?.bannerId);
                // dispatch(
                //   openCustomModalDialog({
                //     modalData: {
                //       deleteHandler,
                //       deleteId: props.data?.bannerId,
                //       deleteType: "banner",
                //     },
                //     modal: "DELETE_MODAL",
                //   })
                // );
              }}
              color="error"
              size="small"
              variant="primary"
              sx={{ marginLeft: 1 }}
            >
              <DeleteIcon width="16px" height="16px" />
            </IconButton>
          </Box>
        );
      },
      cellStyle: { textAlign: "right", justifyContent: "end" },
      headerClass: "right-aligned-cell-header",
      flex: 1,
      minWidth: 100,
      maxWidth: 120,
      pinned: "right",
    },
  ];

  const removeImageHandler = (itemToRemove, gridType, arrayIndex) => {
    if (!itemToRemove || !itemToRemove.index || arrayIndex === undefined) return;

    setFormData((prevFormData) => {
      const updatedCategorySection = prevFormData.categorySection.map((section, idx) => {
        if (idx !== arrayIndex) return section;

        let updatedSection = { ...section };
        if (gridType === "mobileGrid") {
          if (Array.isArray(updatedSection.mobileGrid)) {
            updatedSection.mobileGrid = updatedSection.mobileGrid.filter(
              (item) => item.index !== itemToRemove.index
            );
          }
        } else {
          if (Array.isArray(updatedSection.desktopGrid)) {
            updatedSection.desktopGrid = updatedSection.desktopGrid.filter(
              (item) => item.index !== itemToRemove.index
            );
          }
        }
        return updatedSection;
      });

      return {
        ...prevFormData,
        categorySection: updatedCategorySection,
      };
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAddCategory = () => {
    // Also add a new object (could be customized) into card?.categories array
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };

      // If "categories" array doesn't exist, initialize it
      if (!Array.isArray(updatedFormData.categorySection)) {
        updatedFormData.categorySection = [];
      }

      updatedFormData.categorySection = [
        ...updatedFormData.categorySection,
        {
          categoryName: "",
          bentoGridHeading: "",
          bentoGridHeading1: "",
          layoutType: "No Grid",
          defaultRedirectUrlEnable: false,
          defaultGridUrl: "",
          desktopBanner: {
            imageUrl: "",
            title: "",
            description: "",
            altText: "",
            redirectUrl: "",
          },
          mobileBanner: {
            imageUrl: "",
            title: "",
            description: "",
            altText: "",
            redirectUrl: "",
          },
          desktopGrid: [],
          mobileGrid: [],
          arrayIndex: updatedFormData.categorySection.length,
        },
      ];

      return updatedFormData;
    });
  };
  const allCategoriesSelected =
    allCategoryData?.values?.length > 0 &&
    formData?.categorySection?.length >= allCategoryData?.values?.length;

  const handleRemoveCategory = (cardId) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };
      if (Array.isArray(updatedFormData.categorySection)) {
        // Remove category and reset arrayIndex based on new data set order
        const filteredSections = updatedFormData.categorySection
          .filter((cat) => cat.arrayIndex !== cardId)
          .map((cat, idx) => ({ ...cat, arrayIndex: idx }));
        updatedFormData.categorySection = filteredSections;
      }
      return updatedFormData;
    });
    setCardErrors((prevErrors) => {
      // Remove error entry for the removed card, and resequence errors to match new arrayIndex
      const updatedErrors = { ...prevErrors };
      // Remove the error corresponding to the removed card
      Object.keys(updatedErrors).forEach((key) => {
        // Remove error if the key matches either string or number (support both id and card-index style keys)
        if (key === `${cardId}` || key === `card-${cardId}`) {
          delete updatedErrors[key];
        }
      });
      // Resequence remaining errors' keys if card indices have changed
      // Optional: Only needed if you depend on index-based keys like 'card-0', 'card-1', etc.
      // If you don't care, you can skip this step.
      // Get remaining keys and values for errors that match 'card-'
      const errorEntries = Object.entries(updatedErrors).filter(([key]) => /^card-\d+$/.test(key));
      // Sort by index to keep order
      errorEntries.sort((a, b) => {
        const aIdx = parseInt(a[0].split("-")[1]);
        const bIdx = parseInt(b[0].split("-")[1]);
        return aIdx - bIdx;
      });
      // Rebuild errors object with resequenced keys
      let newErrors = { ...updatedErrors };
      errorEntries.forEach(([key, val], idx) => {
        const newKey = `card-${idx}`;
        if (key !== newKey) {
          delete newErrors[key];
          newErrors[newKey] = val;
        }
      });
      return newErrors;
    });
  };

  const handleSave = (data) => {
    if (typeof data?.arrayIndex !== "number") return;

    setFormData((prev) => {
      const updated = { ...prev };

      updated.categorySection = prev.categorySection.map((section) => {
        if (section.arrayIndex !== data.arrayIndex) return section;

        const updatedSection = { ...section };

        // 🔹 Desktop Banner
        if (data.categorybanner === "desktopBanner") {
          updatedSection.desktopBanner = {
            imageUrl: data.imageUrl,
            title: data.title,
            description: data.description,
            altText: data.altText,
            redirectUrl: data.redirectUrl,
          };
          return updatedSection;
        }

        // 🔹 Mobile Banner
        if (data.categorybanner === "mobileBanner") {
          updatedSection.mobileBanner = {
            imageUrl: data.imageUrl,
            title: data.title,
            description: data.description,
            altText: data.altText,
            redirectUrl: data.redirectUrl,
          };
          return updatedSection;
        }

        // 🔹 GRID UPDATE (THIS WAS THE BUG)
        if (data.type === "Dekstop") {
          const grid = Array.isArray(updatedSection.desktopGrid)
            ? [...updatedSection.desktopGrid]
            : [];

          const idx = grid.findIndex((i) => i.index === data.index);

          if (idx > -1) {
            grid[idx] = data; // ✅ UPDATE
          } else {
            grid.push(data); // ➕ ADD
          }

          updatedSection.desktopGrid = grid;
        } else {
          const grid = Array.isArray(updatedSection.mobileGrid)
            ? [...updatedSection.mobileGrid]
            : [];

          const idx = grid.findIndex((i) => i.index === data.index);

          if (idx > -1) {
            grid[idx] = data; // ✅ UPDATE
          } else {
            grid.push(data); // ➕ ADD
          }

          updatedSection.mobileGrid = grid;
        }

        return updatedSection;
      });

      return updated;
    });
  };
  const onImageClicked = (catergoryData, type, dimensions, index, arrayIndex) => {
    dispatch(
      openCustomModalDialog({
        modal: "ADD_GRID_BANNER",
        modalData: {
          categoryData: categoryData,
          type: "Dekstop",
          dimensions: "386x600",
          index: "1",
          arrayIndex: card?.arrayIndex,
          handleSave: (data) => handleSave(data),
        },
      })
    );
  };

  // const handleDelivery = () => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     deliverySection: {
  //       ...prev.deliverySection,
  //       subData: [
  //         ...prev.deliverySection.subData,
  //         {
  //           image: "",
  //           heading: "",
  //           subHeading: "",
  //           paragraph: "",
  //           deliveryId: crypto.randomUUID(),
  //         },
  //       ],
  //     },
  //   }));
  // };
  // const handleAddFaq = () => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     faqSection: {
  //       ...prev.faqSection,
  //       subData: [
  //         ...prev.faqSection.subData,
  //         {
  //           question: "",
  //           answer: "",
  //           faqId: crypto.randomUUID(),
  //         },
  //       ],
  //     },
  //   }));
  // };

  const handleDelivery = () => {
    const deliveryErrors = validateDeliveryItems(formData.deliverySection?.subData);

    // ❌ Stop adding if any existing delivery item has errors
    if (Object.keys(deliveryErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...deliveryErrors }));

      const firstErrorField = Object.keys(deliveryErrors)[0];

      setTimeout(() => {
        const element = document.querySelector(`[name="${firstErrorField}"]`);

        if (element) {
          const yOffset = -120;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
          element.focus({ preventScroll: true });
        }
      }, 100);

      return; // 🚫 DO NOT ADD DELIVERY CARD
    }

    // ✅ All existing delivery items are valid → add new one
    setFormData((prev) => ({
      ...prev,
      deliverySection: {
        ...prev.deliverySection,
        subData: [
          ...prev.deliverySection.subData,
          {
            image: "",
            heading: "",
            subHeading: "",
            paragraph: "",
            deliveryId: crypto.randomUUID(),
          },
        ],
      },
    }));
  };

  const handleAddFaq = () => {
    const faqErrors = validateFaqItems(formData.faqSection?.subData);

    // ❌ Stop adding if any FAQ has empty question/answer
    if (Object.keys(faqErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...faqErrors }));

      const firstErrorField = Object.keys(faqErrors)[0];

      setTimeout(() => {
        const element = document.querySelector(`[name="${firstErrorField}"]`);

        if (element) {
          const yOffset = -120;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
          element.focus({ preventScroll: true });
        }
      }, 100);

      return; // 🚫 DO NOT ADD FAQ
    }

    // ✅ All previous FAQs valid → add new one
    setFormData((prev) => ({
      ...prev,
      faqSection: {
        ...prev.faqSection,
        subData: [
          ...prev.faqSection.subData,
          {
            question: "",
            answer: "",
            faqId: crypto.randomUUID(),
          },
        ],
      },
    }));
  };

  const handleRemoveDelivery = (indexToRemove) => {
    setErrors((prev) => ({
      ...prev,
      [`deliverySubData_${indexToRemove}_paragraph`]: "",
      [`deliverySubData_${indexToRemove}_heading`]: "",
      [`deliverySubData_${indexToRemove}_subHeading`]: "",
      [`deliverySubData_${indexToRemove}_image`]: "",
    }));
    setFormData((prev) => ({
      ...prev,
      deliverySection: {
        ...prev.deliverySection,
        subData: prev.deliverySection.subData.filter((_item) => _item.deliveryId !== indexToRemove),
      },
    }));
  };

  const handleRemoveFaq = (indexToRemove) => {
    setErrors((prev) => ({
      ...prev,
      [`errors_${indexToRemove}_answer`]: "",
      [`errors_${indexToRemove}_answer`]: "",
    }));
    setFormData((prev) => ({
      ...prev,
      faqSection: {
        ...prev.faqSection,
        subData: prev.faqSection.subData.filter((_item) => _item.faqId !== indexToRemove),
      },
    }));
  };
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      stateCode: isDefaultHomePage ? "HP" : matchedState?.stateCode || formData?.stateCode,
    }));
  }, [isDefaultHomePage, matchedState]);

  const handleCategorySelectChange = (cardId, categoryId) => {
    setCategoryCards((prevCards) =>
      prevCards.map((card) =>
        card.id === cardId ? { ...card, selectedCategoryId: categoryId } : card
      )
    );
  };

  const [footerTab, setFooterTab] = useState("siteMap");
  const selectedMenu = formData?.footerSection?.menusItems[footerTab];

  const [menuItemsIcon, setMenuItemsIcon] = useState([
    { id: "menu-my-account", text: "My Account", icon: <MyAccountIcon /> },
    { id: "menu-contact-us", text: "Contact Us", icon: <ContactUsIcon /> },
    { id: "menu-brands", text: "Brands", icon: <BrandsIcon /> },
    { id: "menu-strains", text: "Strains", icon: <MyAccountIcon /> },
  ]);
  const [menuItems, setMenuItems] = useState([
    { id: "menu-my-account", text: "My Account" },
    { id: "menu-contact-us", text: "Contact Us" },
    { id: "menu-brands", text: "Brands" },
    { id: "menu-strains", text: "Strains" },
  ]);

  const handleFooterTabChange = (event, newValue) => {
    setFooterTab(newValue);
    setActiveItemIndex(null);
  };

  const LocationSelectHandler = useCallback((data) => {
    setNewLocationLink(data);
  }, []);

  // Memoized list of options for the driver select dropdown
  const optionsList = useMemo(() => {
    return (
      locationPageList?.data?.map((data) => ({
        value: data.canonical, // The value to be submitted
        label: data.canonical, // The display label in the dropdown
        locaton_id: data._id,
      })) || []
    );
  }, [locationPageList]);

  const handleDragEnd = (result) => {
    const { destination, source } = result;

    if (!destination) return;
    if (destination.index === source.index) return;

    setFormData((prevData) => {
      const newMenuItems = { ...prevData.footerSection.menusItems };
      const currentMenu = [...newMenuItems[footerTab].subData];
      const [movedItem] = currentMenu.splice(source.index, 1);
      currentMenu.splice(destination.index, 0, movedItem);

      newMenuItems[footerTab].subData = currentMenu;

      return {
        ...prevData,
        footerSection: {
          ...prevData.footerSection,
          menusItems: newMenuItems,
        },
      };
    });
  };
  const linkStyle = {
    color: text.main,
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
  };
  const showError = (message, errortype) => {
    if (errortype === "success") {
      dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
    }
    if (errortype === "error") {
      dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
    }
  };
  const sliderLength =
    formData?.categorySection?.[0]?.layoutType === "Slider"
      ? formData?.categorySection?.[0]?.desktopGrid?.length + 1
      : "";
  const sliderMobileLength =
    formData?.categorySection?.[0]?.layoutType === "Slider"
      ? formData?.categorySection?.[0]?.mobileGrid?.length + 1
      : "";

  const thumbnail = {
    maxWidth: "100px",
    height: "70px",
    borderRadius: "6px",
    objectFit: "cover",
  };

  function formatStateName(state) {
    if (!state) return "";
    return state
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const handleSubDataInput = (cardIndex, field, value) => {
    setFormData((prev) => {
      const updated = { ...prev };

      updated.deliverySection.subData[cardIndex][field] = value;

      return updated;
    });
  };

  useEffect(() => {
    if (mainGridApiRef?.current) {
      if (loading) {
        mainGridApiRef.current.showLoadingOverlay();
      } else if (banners?.total === 0) {
        mainGridApiRef.current.showNoRowsOverlay();
      } else {
        mainGridApiRef.current.hideOverlay();
      }
    }
  }, [banners, loading]);

  useEffect(() => {
    dispatch(getAllCategory());
  }, []);
  const deleteHandler = (bannerId) => {
    setFormData((prev) => ({
      ...prev,
      heroSection: {
        ...prev.heroSection,
        banners: prev.heroSection.banners.filter((b) => b.bannerId !== bannerId),
      },
    }));

    showError("Banner removed", "success");
  };

  const handleAddBanner = (banner) => {
    setFormData((prev) => ({
      ...prev,
      heroSection: {
        ...prev.heroSection,
        banners: [...prev.heroSection.banners, { ...banner, bannerId: crypto.randomUUID() }],
      },
    }));
    setErrors((prev) => ({ ...prev, heroBanners: "" }));
    if (formData?.heroSection?.banners?.length >= 3) {
      setErrors((prev) => ({ ...prev, heroBannersActive: "", heroBanners: "" }));
    }
  };
  const onEditClicked = (banner) => {
    dispatch(
      openCustomModalDialog({
        modal: "ADD_HOME_BANNER",
        modalData: {
          bannerData: banner,
          onSubmit: handleEditBanner,
        },
      })
    );
  };
  // In your parent component:
  const handleGridError = React.useCallback((cardId, error) => {
    setCardErrors((prev) => {
      // Only update if the error actually changed
      if (prev[cardId] === error) return prev;
      return {
        ...prev,
        [cardId]: error,
      };
    });
  }, []);

  const handleEditBanner = (updatedBanner) => {
    setFormData((prev) => ({
      ...prev,
      heroSection: {
        ...prev.heroSection,
        banners: prev.heroSection.banners.map((banner) =>
          banner.bannerId === updatedBanner.bannerId ? updatedBanner : banner
        ),
      },
    }));
  };

  const handleAddItems = (subData) => {
    setFormData((prev) => {
      const currentMenu = prev.footerSection.menusItems[footerTab];

      const updatedSubData = Array.isArray(currentMenu.subData)
        ? [...currentMenu.subData, { ...subData, itemId: crypto.randomUUID() }]
        : [{ ...subData, itemId: crypto.randomUUID() }];

      return {
        ...prev,
        footerSection: {
          ...prev.footerSection,
          menusItems: {
            ...prev.footerSection.menusItems,
            [footerTab]: {
              ...currentMenu,
              subData: updatedSubData,
            },
          },
        },
      };
    });
  };
  const handleEditItem = (updatedItem) => {
    setFormData((prev) => {
      const currentMenu = prev.footerSection.menusItems[footerTab];

      const updatedSubData = currentMenu.subData.map((item) =>
        item.itemId === updatedItem.itemId ? { ...updatedItem } : item
      );

      return {
        ...prev,
        footerSection: {
          ...prev.footerSection,
          menusItems: {
            ...prev.footerSection.menusItems,
            [footerTab]: {
              ...currentMenu,
              subData: updatedSubData,
            },
          },
        },
      };
    });
  };

  // const updateDeliveryField = (index, key, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     deliverySection: {
  //       ...prev.deliverySection,
  //       subData: prev.deliverySection.subData.map((sub) =>
  //         sub.deliveryId === index ? { ...sub, [key]: value } : sub
  //       ),
  //     },
  //   }));
  // };

  const updateDeliveryField = (deliveryId, key, value) => {
    setFormData((prev) => ({
      ...prev,
      deliverySection: {
        ...prev.deliverySection,
        subData: prev.deliverySection.subData.map((sub) =>
          sub.deliveryId === deliveryId ? { ...sub, [key]: value } : sub
        ),
      },
    }));
  };
  const updateFaqField = (index, key, value) => {
    setFormData((prev) => ({
      ...prev,
      faqSection: {
        ...prev.faqSection,
        subData: prev.faqSection.subData.map((item) =>
          item.faqId === index ? { ...item, [key]: value } : item
        ),
      },
    }));
  };

  useEffect(() => {
    if (!mainGridApiRef.current) return;

    const ds = { getRows };
    mainGridApiRef.current.setDatasource(ds);
    mainGridApiRef.current.refreshInfiniteCache();
  }, [formData.heroSection.banners]);

  const handleFileChange = async (event, deliveryId) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;

    // Allow only images
    if (!selectedFile.type.startsWith("image/")) {
      alert("Please upload a valid image file.");
      return;
    }

    const body = new FormData();
    body.append("filePath", selectedFile);

    try {
      // Optional: show loader
      dispatch(setModalLoader(true));

      // Upload the image
      const res = await dispatch(uploadImage(body)).unwrap();

      // Update the form data for the deliverySection
      setFormData((prev) => {
        const updatedSubData = prev.deliverySection.subData.map((item) => {
          // Update the image of the item that matches the index (or another identifier)
          if (item.deliveryId === deliveryId) {
            return { ...item, image: res.fileUrl };
          }
          return item;
        });

        return {
          ...prev,
          deliverySection: {
            ...prev.deliverySection,
            subData: updatedSubData, // Update the subData with new image
          },
        };
      });
    } catch (err) {
      alert("Image upload failed. Try again.");
    } finally {
      dispatch(setModalLoader(false));
    }
  };
  const validURL = (url) => {
    const urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})" + // domain name
      "(\\:\\d+)?" + // port
      "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
      "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment
      "i"
    );
    return !!urlPattern.test(url);
  };

  const addLocationHandler = () => {
    let newErrors = {};
    if (!newLocationName.trim()) {
      setErrors((prev) => ({
        ...prev,
        locationName: "Type Location Name",
      }));
      return;
    }
    if (!newLocationLink.trim()) {
      // If editing and location link is empty, delete the location
      if (isEdit && editingLocationId) {
        handleRemoveLocation(editingLocationId);
        setNewLocationName("");
        setNewLocationLink("");
        setNewLocationId("");
        setIsEdit(false);
        setEditingLocationId(null);
        setErrors((prev) => ({ ...prev, locationName: "", locationLink: "" }));
        return;
      }
      setErrors((prev) => ({
        ...prev,
        locationLink: "Location Link is required",
      }));
      return;
    } else if (!validURL(newLocationLink.trim())) {
      setErrors((prev) => ({
        ...prev,
        locationLink: "Invalid Link",
      }));
      return;
    }

    if (newLocationName && newLocationLink) {
      if (isEdit && editingLocationId) {
        // Update existing location
        setFormData((prev) => ({
          ...prev,
          footerSection: {
            ...prev.footerSection,
            locationList: prev.footerSection.locationList.map((location) =>
              location.location_id === editingLocationId || location._id === editingLocationId
                ? {
                  ...location,
                  locationName: newLocationName,
                  locationLink: newLocationLink,
                  location_id: newLocationId || location.location_id || location._id,
                }
                : location
            ),
          },
        }));
      } else {
        // Add new location
        setFormData((prev) => ({
          ...prev,
          footerSection: {
            ...prev.footerSection,
            locationList: [
              ...(prev.footerSection?.locationList || []),
              {
                locationName: newLocationName,
                locationLink: newLocationLink,
                location_id: newLocationId,
              },
            ],
          },
        }));
      }

      // Clear the inputs after adding/updating
      setNewLocationName("");
      setNewLocationLink("");
      setNewLocationId("");
      setIsEdit(false);
      setEditingLocationId(null);
      setErrors((prev) => ({ ...prev, locationName: "", locationLink: "" }));
    }
  };

  const handleRemoveImageDelivery = (index) => {
    // Create a new array to avoid mutating the original array
    const updatedData = formData.deliverySection.subData.map((item, i) => {
      if (i === index) {
        // Create a new object for the item at the specified index and remove the image
        return { ...item, image: null };
      }
      return item; // Return the item as-is if it's not the one to modify
    });

    // Update the formData state with the new subData array
    setFormData({
      ...formData,
      deliverySection: {
        ...formData.deliverySection,
        subData: updatedData,
      },
    });
  };

  useEffect(() => {
    if (!id && !isDefaultHomePage) return;
    // setFormData({ ...initialState });
    dispatch(getHomePageById({ id, isDefaultHomePage: isDefaultHomePage }))
      .unwrap()
      .then((res) => {
        if (!res?.data) return;

        const data = res.data;
        setStateName(data.stateName);

        // ⭐ Add UUID to banners (safe)
        const bannersWithIds = (data.heroSection?.banners || []).map((b) => ({
          ...b,
          bannerId: crypto.randomUUID(),
        }));
        const deliveryWithId = (data.deliverySection?.subData || []).map((b) => ({
          ...b,
          deliveryId: crypto.randomUUID(),
        }));
        const faqWithId = (data.faqSection?.subData || []).map((b) => ({
          ...b,
          faqId: crypto.randomUUID(),
        }));

        // ⭐ Fix menusItems mapping (handle overView separately)
        const menusItemsWithIds = Object.fromEntries(
          Object.entries(data.footerSection?.menusItems || {}).map(([key, menu]) => {
            const { subData, ...restMenu } = menu;

            // ⭐ CASE 1: overView → subData is OBJECT
            if (key === "overView") {
              return [
                key,
                {
                  ...restMenu,
                  subData: {
                    cta1: {
                      label: subData?.cta1?.label || "",
                      url: subData?.cta1?.url || "",
                    },
                    cta2: {
                      label: subData?.cta2?.label || "",
                      url: subData?.cta2?.url || "",
                    },
                    description: subData?.description || "",
                  },
                },
              ];
            }

            // ⭐ CASE 2: other menus → subData is ARRAY
            return [
              key,
              {
                ...restMenu,
                subData: (subData || []).map((item) => ({
                  ...item,
                  itemId: crypto.randomUUID(),
                })),
              },
            ];
          })
        );

        const updatedCategorySection = Array.isArray(res?.data.categorySection)
          ? res?.data.categorySection.map((section, idx) => {
            // add type:"Dekstop" to desktopGrid, type:"Mobile" to mobileGrid elements
            const desktopGrid = Array.isArray(section.desktopGrid)
              ? section.desktopGrid.map((el) => ({
                ...el,
                type: "Dekstop",
              }))
              : [];
            const mobileGrid = Array.isArray(section.mobileGrid)
              ? section.mobileGrid.map((el) => ({
                ...el,
                type: "Mobile",
              }))
              : [];
            return {
              ...section,
              arrayIndex: typeof section.arrayIndex === "number" ? section.arrayIndex : idx,
              desktopGrid,
              mobileGrid,
            };
          })
          : [];
        // ⭐ Final formData initialization
        setFormData({
          ...data,
          heroSection: {
            ...data.heroSection,
            banners: bannersWithIds,
          },
          deliverySection: {
            ...data.deliverySection,
            subData: deliveryWithId,
          },
          faqSection: {
            ...data.faqSection,
            subData: faqWithId,
          },
          footerSection: {
            ...data.footerSection,
            menusItems: menusItemsWithIds,
            locationList: data?.footerSection?.locationList?.map((item) => {
              return {
                ...item,
                location_id: item._id,
              };
            }),
          },
          categorySection: updatedCategorySection,
        });

      })
      .catch((err) => {
      });
  }, [id]);

  const handleAddCta = () => {
    setFormData((prev) => ({
      ...prev,
      footerSection: {
        ...prev.footerSection,
        overView: {
          ...prev.footerSection.overView,
          cta: [
            ...prev.footerSection.overView.cta,
            {
              label: "",
              url: "",
              openNewTab: false,
            },
          ],
        },
      },
    }));
  };
  const handleRemoveCta = (index) => {
    setFormData((prev) => ({
      ...prev,
      footerSection: {
        ...prev.footerSection,
        overView: {
          ...prev.footerSection.overView,
          cta: prev.footerSection.overView.cta.filter((_, i) => i !== index),
        },
      },
    }));
  };

  const handleSubmitButton = (status) => {
    const { errors, isValid } = homePageValidation(formData, id ? false : true);
    const hasMenuNameErrors = Object.values(menuNameError).some(Boolean);

    if (status === "published") {
      if (!isValid || hasMenuNameErrors) {
        setErrors(errors);
        if (hasMenuNameErrors) {
          const firstErrorTab = getFirstMenuErrorTab();
          if (firstErrorTab) {
            setFooterTab(firstErrorTab);
            showError(menuNameError[firstErrorTab], "error");
          }
          return;
        }
        const firstErrorField = Object.keys(errors)[0];
        showError(errors[firstErrorField], "error");


        if (firstErrorField) {
          // Wait for DOM to be ready and errors to render
          setTimeout(() => {
            const element = document.querySelector(`[name="${firstErrorField}"]`);

            if (firstErrorField === "stateName" || firstErrorField === "city") {
              window.scrollTo({ top: 0, behavior: "smooth" });
              return;
            }

            if (element) {
              // Scroll with offset for headers
              const yOffset = -120; // Adjust based on your header height
              const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

              window.scrollTo({ top: y, behavior: "smooth" });

              // Focus the element
              element.focus({ preventScroll: true });
            } else {
              console.warn(`Element with name="${firstErrorField}" not found`);
            }
          }, 100); // Small delay to ensure DOM updates
        }

        return;
      }
    }
    setErrors({});
    setMenuNameError("");

    const payload = {
      ...formData,
      isDefaultHomePage: isDefaultHomePage,
      status: status,
      heroSection: {
        ...formData.heroSection,
        banners: formData.heroSection?.banners?.map(({ bannerId, ...banner }) => banner) || [],
      },
      deliverySection: {
        ...formData.deliverySection,
        subData: formData.deliverySection?.subData?.map(({ deliveryId, ...rest }) => rest) || [],
      },
      faqSection: {
        ...formData.faqSection,
        subData: formData.faqSection?.subData?.map(({ faqId, ...rest }) => rest) || [],
      },

      footerSection: {
        ...formData.footerSection,
        locationList: formData.footerSection?.locationList,
        menusItems: Object.fromEntries(
          Object.entries(formData.footerSection?.menusItems || {}).map(([key, menu]) => {
            const { subData, ...restMenu } = menu;

            // ⭐ CASE 1: overView → subData is object (cta1, cta2, description)
            if (key === "overView") {
              return [
                key,
                {
                  ...restMenu,
                  subData: {
                    cta1: {
                      label: subData?.cta1?.label || "",
                      url: subData?.cta1?.url || "",
                    },
                    cta2: {
                      label: subData?.cta2?.label || "",
                      url: subData?.cta2?.url || "",
                    },
                    description: subData?.description || "",
                  },
                },
              ];
            }

            // ⭐ CASE 2: other menus → subData is array
            return [
              key,
              {
                ...menu,
                subData: Array.isArray(subData) ? subData.map(({ itemId, ...item }) => item) : [],
              },
            ];
          })
        ),
      },
    };
    dispatch(createHomepageHit({ payload, id, isDefaultHomePage: payload.isDefaultHomePage }))
      .unwrap()
      .then((res) => {
        showError(res?.message, "success");
        navigate(-1);
      })
      .catch((err) => {
        showError(err?.message, "error");
      });
  };
  useEffect(() => {
    dispatch(
      getLocationPageList({
        skip: 0,
        limit: 100,
        searchTerm: "",
        stateCode: isDefaultHomePage ? "" : matchedState?.stateCode || formData?.stateCode,
      })
    );
  }, [matchedState?.stateCode, formData?.stateCode]);
  const handleRemoveLocation = (id) => {
    setFormData((prev) => ({
      ...prev,
      footerSection: {
        ...prev.footerSection,
        locationList: prev.footerSection.locationList.filter(
          (b) => b.location_id !== id && b._id !== id
        ),
      },
    }));
  };

  const handleRemoveItem = (list, indexToRemove) => {
    setFormData((prev) => ({
      ...prev,
      footerSection: {
        ...prev.footerSection,
        menusItems: {
          ...prev.footerSection.menusItems,
          [footerTab]: {
            ...prev.footerSection.menusItems[footerTab],
            subData: list.filter((_, i) => i !== indexToRemove),
          },
        },
      },
    }));
  };

  const validateFaqItems = (subData = []) => {
    const errors = {};

    const isQuillEmpty = (val = "") => {
      const v = val.trim();
      return v === "" || v === "<p><br></p>" || v === "<br>" || v === "<p></p>";
    };

    subData.forEach((item) => {
      if (isQuillEmpty(item.question)) {
        errors[`faq_${item.faqId}_question`] = "Question in FAQ section is required";
      }

      if (isQuillEmpty(item.answer)) {
        errors[`faq_${item.faqId}_answer`] = "Answer in FAQ section is required";
      }
    });

    return errors;
  };

  const handleToggleActive = (menu, isActive) => {
    setFormData((prev) => {
      const updatedMenusItems = {
        ...prev.footerSection.menusItems,
        [menu]: {
          ...prev.footerSection.menusItems[menu],
          isActive: isActive, // Dynamically set active or inactive state
        },
      };

      return {
        ...prev,
        footerSection: {
          ...prev.footerSection,
          menusItems: updatedMenusItems,
        },
      };
    });
  };
  useEffect(() => {
    if (activeItem) {
      setDraftItem({ ...activeItem });
    }
  }, [activeItemIndex]);

  const handleSaveItem = () => {
    setFormData((prev) => ({
      ...prev,
      footerSection: {
        ...prev.footerSection,
        menusItems: {
          ...prev.footerSection.menusItems,
          [footerTab]: {
            ...prev.footerSection.menusItems[footerTab],
            subData: prev.footerSection.menusItems[footerTab].subData.map(
              (item, index) =>
                index === activeItemIndex ? draftItem : item
            ),
          },
        },
      },
    }));
    setActiveItemIndex(null);
  };

  // useEffect(()=>{
  //  dispatch(getPageList()).unwrap().then((res)=>{
  //    if(res){
  //      setPageList(res?.data)
  //    }
  //  })
  // },[])


  const [heroOpen, setHeroOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [reviewOpen, setReviewOpen] = useState(false);
  const [deliveryOpen, setDeliveryOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  const [footerOpen, setFooterOpen] = useState(false);
  const [contentOpen, setContentOpen] = useState(false);

  // Section headings state
  const [sectionHeadings, setSectionHeadings] = useState({
    heroSection: { label: "Hero Section", section_type: "hero_section" },
    categorySection: { label: "Category Section", section_type: "category_section" },
    customerSection: { label: "Customer Reviews Section", section_type: "customer_section" },
    deliverySection: {
      label: "California's Favorite Cannabis Delivery Section",
      section_type: "delivery_section",
    },
    contentSection: { label: "Content Section", section_type: "content_section" },
    faqSection: { label: "FAQ Section", section_type: "faq_section" },
    footerSection: { label: "Footer Section", section_type: "footer_section" },
  });
  const [editingHeading, setEditingHeading] = useState(null);
  const [tempHeadingValue, setTempHeadingValue] = useState("");

  // Auto-open when hero-related errors appear
  useEffect(() => {
    const hasHeroError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("hero") && value?.trim()
    );
    const hasCategoryError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("category") && value?.trim()
    );
    const hasReviewError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("customer") && value?.trim()
    );
    const hasDeliveryError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("delivery") && value?.trim()
    );
    const hasContentError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("statePara") && value?.trim()
    );
    const hasFaqError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("faq") && value?.trim()
    );
    const hasFooterError = Object.entries(errors).some(
      ([key, value]) => key.startsWith("overView") || (key.startsWith("location") && value?.trim())
    );

    if (hasHeroError) {
      setHeroOpen(true);
    }
    if (hasCategoryError) {
      setCategoryOpen(true);
    }
    if (hasReviewError) {
      setReviewOpen(true);
    }
    if (hasDeliveryError) {
      setDeliveryOpen(true);
    }
    if (hasContentError) {
      setContentOpen(true);
    }
    if (hasFaqError) {
      setFaqOpen(true);
    }
    if (hasFooterError) {
      setFooterOpen(true);
    }
  }, [errors]);

  useEffect(() => {
    dispatch(
      getHomePageStateList({
        skip: pageRef.current,
        limit: 1000,
      })
    )
      .unwrap()
      .then((res) => {
        pageRef.current = pageRef.current + 10;
        const mappedStates = (res?.data || []).map((item) => ({
          value: item.stateName.toLowerCase().replace(/\s+/g, "_"),
          label: item.stateName,
          stateCode: item.stateCode,
          _id: item._id,
        }));

        setStates(mappedStates);
      });
  }, []);
  const getFirstMenuErrorTab = () => {
    return Object.keys(formData.footerSection.menusItems).find((key) => menuNameError[key]);
  };
  const activeItem = selectedMenu?.subData?.[activeItemIndex] || null;
  const validateDeliveryItems = (subData = []) => {
    const errors = {};

    subData.forEach((item) => {
      if (!item.image?.trim()) {
        errors[`deliverySubData_${item.deliveryId}_image`] = "Delivery section icon is required";
      }

      if (!item.heading?.trim()) {
        errors[`deliverySubData_${item.deliveryId}_heading`] =
          "Heading in delivery section item is required";
      }

      if (!item.subHeading?.trim()) {
        errors[`deliverySubData_${item.deliveryId}_subHeading`] =
          "Sub-heading in delivery section item is required";
      }

      if (!item.paragraph?.trim()) {
        errors[`deliverySubData_${item.deliveryId}_paragraph`] =
          "Paragraph in delivery section item is required";
      }
    });

    return errors;
  };

  // Handle heading editing functions
  const handleEditHeading = (sectionKey) => {
    setEditingHeading(sectionKey);
    setTempHeadingValue(sectionHeadings[sectionKey].label);
  };

  const handleSaveHeading = (sectionKey) => {
    if (tempHeadingValue.trim()) {
      setSectionHeadings((prev) => ({
        ...prev,
        [sectionKey]: {
          ...prev[sectionKey],
          label: tempHeadingValue.trim(),
        },
      }));
    }
    setEditingHeading(null);
    setTempHeadingValue("");
  };

  const handleCancelHeading = () => {
    setEditingHeading(null);
    setTempHeadingValue("");
  };

  // Sections configuration for dynamic rendering
  const sectionsConfig = [
    {
      key: "heroSection",
      section_type: "hero_section",
      enabled: true,
      order: 1,
      component: HeroSection,
    },
    {
      key: "categorySection",
      section_type: "category_section",
      enabled: true,
      order: 2,
      component: CategorySection,
    },
    {
      key: "customerSection",
      section_type: "customer_section",
      enabled: true,
      order: 3,
      component: CustomerReview,
    },
    {
      key: "deliverySection",
      section_type: "delivery_section",
      enabled: true,
      order: 4,
      component: FavDeliverySection,
    },
    {
      key: "contentSection",
      section_type: "content_section",
      enabled: true,
      order: 5,
      component: ContentSection,
    },
    {
      key: "faqSection",
      section_type: "faq_section",
      enabled: true,
      order: 6,
      component: FAQSection,
    },
    {
      key: "footerSection",
      section_type: "footer_section",
      enabled: true,
      order: 7,
      component: FooterSection,
    },
  ];

  // Get section props configuration
  const getSectionProps = (sectionKey) => {
    const commonHeadingProps = {
      sectionHeading: sectionHeadings[sectionKey].label,
      isEditingHeading: editingHeading === sectionKey,
      tempHeadingValue: tempHeadingValue,
      setTempHeadingValue: setTempHeadingValue,
      onEditHeading: handleEditHeading,
      onSaveHeading: handleSaveHeading,
      onCancelHeading: handleCancelHeading,
    };

    const sectionPropsMap = {
      heroSection: {
        heroOpen,
        setHeroOpen,
        formData,
        setFormData,
        errors,
        setErrors,
        mainGridApiRef,
        getRows,
        pageRef,
        loading,
        columnDefs,
        handleAddBanner,
        dispatch,
        ...commonHeadingProps,
      },
      categorySection: {
        categoryOpen,
        setCategoryOpen,
        formData,
        setFormData,
        handleSave,
        errors,
        setErrors,
        allCategoryData,
        handleRemoveCategory,
        handleAddCategory,
        allCategoriesSelected,
        gridConfigs,
        removeImageHandler,
        dispatch,
        sliderLength,
        sliderMobileLength,
        ...commonHeadingProps,
      },
      customerSection: {
        reviewOpen,
        setReviewOpen,
        formData,
        setFormData,
        errors,
        setErrors,
        ...commonHeadingProps,
      },
      deliverySection: {
        isDefaultHomePage,
        stateName,
        deliveryOpen,
        setDeliveryOpen,
        formData,
        setFormData,
        errors,
        setErrors,
        handleRemoveDelivery,
        handleFileChange,
        handleDelivery,
        updateDeliveryField,
        ...commonHeadingProps,
      },
      contentSection: {
        contentOpen,
        setContentOpen,
        formData,
        setFormData,
        errors,
        setErrors,
        isDefaultHomePage,
        stateName,
        ...commonHeadingProps,
      },
      faqSection: {
        faqOpen,
        setFaqOpen,
        formData,
        setFormData,
        errors,
        setErrors,
        updateFaqField,
        handleRemoveFaq,
        handleAddFaq,
        ...commonHeadingProps,
      },
      footerSection: {
        footerOpen,
        setFooterOpen,
        handleAddCta,
        handleRemoveCta,
        handleRemoveItem,
        activeItem,
        draftItem,
        setDraftItem,
        handleSaveItem,
        setActiveItemIndex,
        activeItemIndex,
        formData,
        handleRemoveLocation,
        overViewPageList,
        setOverViewPageList,
        setFormData,
        errors,
        setErrors,
        footerTab,
        selectedMenu,
        menuNameError,
        newLocationName,
        newLocationId,
        locationPageList,
        addLocationHandler,
        isEdit,
        newLocationLink,
        setMenuNameError,
        handleFooterTabChange,
        handleDragEnd,
        dispatch,
        handleAddItems,
        handleEditItem,
        handleToggleActive,
        setNewLocationName,
        setNewLocationLink,
        setNewLocationId,
        setIsEdit,
        setEditingLocationId,
        ...commonHeadingProps,
      },
    };

    return sectionPropsMap[sectionKey] || {};
  };

  // Dynamic section rendering function
  const renderSectionsDynamically = () => {
    return sectionsConfig
      .filter((section) => section.enabled) // Only enabled sections
      .sort((a, b) => a.order - b.order) // Sort by order
      .map((section) => {
        const Component = section.component;
        const props = getSectionProps(section.key);

        return <Component key={section.key} {...props} />;
      });
  };

  // Helper function to toggle section enabled state
  const toggleSection = (sectionKey) => {
    // This could be used to dynamically enable/disable sections
    // For now, just demonstrating the concept
  };

  return (
    <CommonLayout>
      <Grid item xs={12} sm={4} md={2} xxl={2} className="static-pages-container">
        <Box p={{ xs: 2, sm: 3, lg: 4 }} style={{ paddingBottom: 0 }}>
          {/* ********************** HomePage ********************* */}
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
              <span
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <AngleRightIcon fontSize="14px" />
                <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                  {isDefaultHomePage ? "Back" : "State Page"}
                </Typography>
              </span>
            </Box>
          </Box>
          <div>
            {/********************** Page Title **********************/}
            <Card
              sx={{
                p: { xs: 2, md: 3 },
                mb: 2,
                borderRadius: 2.5,
                boxShadow: "none",
              }}
            >
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="h4" color="#9A9AAF" fontWeight="semibold">
                  {isDefaultHomePage ? "Home Page" : `State Page for ${stateName}`}
                </Typography>
                <Box
                  display="flex"
                  sx={{ cursor: "pointer" }}
                  alignItems="center"
                  color="text.main"
                  lineHeight={1}
                  gap={2}
                  style={{ position: "relative" }}
                >
                  {id && formData?.canonical && (
                    <>
                      <Tooltip title={copyStatus ? copyStatus : "Copy"} arrow>
                        <IconButton
                          onClick={() => handleCopyLink(formData?.canonical)}
                          size="small"
                          sx={{ color: "primary.main" }}
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Typography
                        variant="body"
                        component="a"
                        href={formData?.canonical}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ textDecoration: "none", color: "inherit" }}
                        style={{
                          borderRadius: "26px",
                          color: "#0163FF",
                          fontSize: "14px",
                          fontWeight: "600",
                          border: "1px solid #0163FF",
                          padding: "10px 16px",
                        }}
                      // onClick={(event) => event.preventDefault()}
                      >
                        {formData?.canonical}
                      </Typography>
                    </>
                  )}
                  {isDefaultHomePage && (
                    <>
                      <Tooltip title={copyStatus ? copyStatus : "Copy"} arrow>
                        <IconButton
                          onClick={() => handleCopyLink("https://hyperwolf.com/shop")}
                          size="small"
                          sx={{ color: "primary.main" }}
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Typography
                        variant="body"
                        component="a"
                        href={formData?.canonical}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ textDecoration: "none", color: "inherit" }}
                        style={{
                          borderRadius: "26px",
                          color: "#0163FF",
                          fontSize: "14px",
                          fontWeight: "600",
                          border: "1px solid #0163FF",
                          padding: "10px 16px",
                        }}
                      // onClick={(event) => event.preventDefault()}
                      >
                        {"https://hyperwolf.com/shop"}
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>
            </Card>

            {/********************** Meta Tags **********************/}
            <Card
              sx={{
                p: { xs: 2, md: 3 },
                mb: 2,
                borderRadius: 2.5,
                boxShadow: "none",
              }}
            >
              <Typography variant="h5" fontWeight="semibold" mb={2}>
                Meta Properties
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="h1"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    Heading (H1)
                  </Typography>
                  <TextField
                    label="Meta Title"
                    className="form-input"
                    fullWidth
                    placeholder=""
                    value={formData?.metaTitle}
                    name="metaTitle"
                    error={Boolean(errors?.metaTitle)}
                    helperText={errors?.metaTitle}
                    onChange={(e) => {
                      setErrors((prev) => ({ ...prev, metaTitle: "" }));
                      setFormData((prev) => ({
                        ...prev,
                        metaTitle: e.target.value,
                      }));
                    }}
                  />
                  <span className="drag_drop">
                    Character Count: {formData?.metaTitle?.length}{" "}
                    <span>(Recommended Characters: 60)</span>
                  </span>
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    label="Meta Description"
                    className="form-input"
                    fullWidth
                    placeholder=""
                    name="metaDescription"
                    value={formData?.metaDescription}
                    error={Boolean(errors?.metaDescription)}
                    helperText={errors?.metaDescription}
                    onChange={(e) => {
                      setErrors((prev) => ({ ...prev, metaDescription: "" }));
                      setFormData((prev) => ({
                        ...prev,
                        metaDescription: e.target.value,
                      }));
                    }}
                  />
                  <span className="drag_drop">
                    Character Count: {formData?.metaDescription?.length}{" "}
                    <span>(Recommended Characters: 160)</span>
                  </span>
                </Grid>
              </Grid>
            </Card>
          </div>

          {/* Dynamic Section Rendering */}
          {renderSectionsDynamically()}

          {/* ************************ submit handler ****************************** */}
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25} my={4}>
            <MDButton
              sx={{ minWidth: "160px" }}
              type="button"
              variant="contained"
              color="primary"
              disabled={updateloading}
              onClick={() => {
                handleSubmitButton("published");
              }}
            >
              {updateloading ? "Loading..." : "Publish"}
            </MDButton>

            <MDButton
              sx={{ minWidth: "160px" }}
              type="button"
              variant="outlined"
              color="dark"
              className="dark-outlined-btn"
              onClick={() => {
                handleSubmitButton("draft");
                // navigate("/homepage");
              }}
            >
              Draft
            </MDButton>

            <MDButton
              sx={{ minWidth: "160px", backgroundColor: "#fdd5d3 !important", color: "#FD4438" }}
              type="button"
              variant="outlined"
              color="error"
              className="dark-outlined-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </MDButton>
          </Stack>
        </Box>
      </Grid>
    </CommonLayout>
  );
}
